import { useCallback, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { availableAccessorialCodesQueryOptions, filterAvailableAccessorialCodes } from '../data-provider';

export const useAvailableAccessorialCodes = () => {
  const [search, setSearch] = useState('');

  const { data, isLoading, isError } = useQuery(availableAccessorialCodesQueryOptions());

  const filteredData = useMemo(() => {
    if (!data) {
      return undefined;
    }

    return filterAvailableAccessorialCodes(data, search);
  }, [data, search]);

  const updateFilters = useCallback((query: string) => {
    setSearch(query);
  }, []);

  return {
    data: filteredData ?? data,
    isError,
    isLoading,
    updateFilters,
  };
};
